import * as serializers from './serializers'
import { RvStatement, RvSummary } from './types'
import client from '../../client'
import { ResponseSuccess } from '../../types'
import { BUSINESS_CODE } from '../auth'

export const getRvStatement = async () =>
  await client.get<ResponseSuccess<RvStatement>>(`v1/statement`)

export const getRvSummary = async (businessCode: BUSINESS_CODE, microRegionCode?: string) =>
  serializers.getRvSummary(
    await client.get<ResponseSuccess<RvSummary>>(
      `${businessCode === BUSINESS_CODE.GOODS_AND_SERVICES ? 'v2' : 'v1'}/statement`,
      {
        params: {
          microrregion_code: microRegionCode
        }
      }
    ),
    businessCode
  )
